import React, { useEffect, useContext } from "react";
import { XAxis, YAxis, CartesianGrid, Tooltip, Legend, BarChart, Bar } from "recharts";

import styles from "./style.module.scss";

import { MainContext } from "../../context/MainContext";
import { setService } from "../../helpers/setService";

export default function StatisticsTabs() {
  const { markers, serviceByDate, setServiceByDate } = useContext(MainContext);

  useEffect(() => {
    const res = setService(markers);
    setServiceByDate(res);
  }, [markers, setServiceByDate]);

  const formatTick = (tick) => {
    return tick.split(".")[0];
  };

  const formatLegend = (count, entry) => {
    const customNames = {
      count: "Техническое обслуживание",
    };

    return customNames[count] || count;
  };

  return (
    <section className={styles.statistics_section}>
      <BarChart
        width={460}
        height={300}
        data={serviceByDate.slice(-10)}
        margin={{
          top: 5,
          right: 40,
          left: 0,
          bottom: 5,
        }}
        barSize={12}
      >
        <XAxis
          dataKey="date"
          tickFormatter={formatTick}
          scale="point"
          padding={{ left: 10, right: 10 }}
        />
        <YAxis />
        <Tooltip />
        <Legend formatter={formatLegend} />
        <CartesianGrid strokeDasharray="3 3" />
        <Bar
          dataKey="count"
          fill="#41f500"
          background={{ fill: "#2f3439" }}
          label={{ position: "top", color: "#fff" }}
        />
      </BarChart>
    </section>
  );
}
